module.exports = __webpack_public_path__ + "static/media/organisations.acb3bf68.svg";